import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IResetPasswordData } from '../../../models/auth.model';
import { BaseApiService } from '../../base-api/base-api.service';

@Injectable({
    providedIn: 'root',
})
export class PasswordService extends BaseApiService {
    protected override endPoint = '/password';

    forgotPassword(email: string): Observable<void> {
        return this.http.post<void>(`${this.fullPath}/forgot`, { email });
    }

    resetPassword(data: IResetPasswordData): Observable<void> {
        return this.http.post<void>(`${this.fullPath}/reset`, data);
    }
}
